module.exports = __webpack_public_path__ + "static/media/strike.a5621ede.mp3";